export default function deleteObjective(){
	return `mutation DeleteObjective(
		$objective_id: String!
	) {
		deleteObjective(
			objective_id: $objective_id
		)
	}`;
}
